import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { RESOURCE_TYPE } from '../../constants';
import { withAllowedOperationsProvider } from '../../hocs';
import AssignShiftForm from '../AssignShiftForm/AssignShiftForm';
import BulkAssignShiftForm from '../BulkAsignShiftForm/BulkAssignShiftForm';
import NextMonthVinForm from '../NextMonthVinForm/NextMonthVinForm';
import AddTyerAndothersForm from '../AddTyerAndothersForm/AddTyerAndothersForm';

const BulkOptionsToolbar = ({
  activeAsnDate,
  selectedAsns,
  asns,
  reloadData,
  handleClose,
  isAssignShiftFormOpen,
  isNextMonthFormOpen,
  isAddTyerAndOthersOpen,
  assignShift,
  bulkAssignShift,
  classNames = {},
  title = 'ASN',
  shifts,
  nextMonthVINRequest,
  activeTyreAndOthersRequest,
  isAssignShiftFormDataLoading,
  closeNextMonthVinForm,
  closeAddTyerAndOthers,
}) => {
  const [isBulkAssignShiftFormOpen, setIsBulkAssignShiftFormOpen] = useState(
    false,
  );

  const openBulkAssignShiftClick = () => {
    setIsBulkAssignShiftFormOpen(true);
  };

  const closeBulkAssignShiftForm = () => {
    setIsBulkAssignShiftFormOpen(false);
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '80%', height: '40%' }}>
        {
          isAssignShiftFormOpen && (
            <AssignShiftForm
              open={isAssignShiftFormOpen}
              closeForm={handleClose}
              activeAsnDate={activeAsnDate}
              shifts={shifts}
              openBulkAssignShiftForm={openBulkAssignShiftClick}
              asns={selectedAsns}
              reloadData={reloadData}
              isLoading={isAssignShiftFormDataLoading}
              assignShift={assignShift}
              classNames={classNames}
              title={title}
            />
          )
        }
        {
          isNextMonthFormOpen && (
            <NextMonthVinForm
              open={isNextMonthFormOpen}
              closeForm={closeNextMonthVinForm}
              activeAsnDate={activeAsnDate}
              openBulkAssignShiftForm={openBulkAssignShiftClick}
              asns={selectedAsns}
              reloadData={reloadData}
              isLoading={isAssignShiftFormDataLoading}
              nextMonthVINRequest={nextMonthVINRequest}
              classNames={classNames}
              title={title}
            />
          )
        }
       {
          isAddTyerAndOthersOpen && (
            <AddTyerAndothersForm
              open={isAddTyerAndOthersOpen}
              closeForm={closeAddTyerAndOthers}
              activeAsnDate={activeAsnDate}
              openBulkAssignShiftForm={openBulkAssignShiftClick}
              asns={selectedAsns}
              reloadData={reloadData}
              isLoading={isAssignShiftFormDataLoading}
              activeTyreAndOthersRequest={activeTyreAndOthersRequest}
              classNames={classNames}
              title={title}
            />
          )
        }
      </div>
      {title !== 'ASN' && (
        <BulkAssignShiftForm
          open={isBulkAssignShiftFormOpen}
          closeForm={closeBulkAssignShiftForm}
          activeAsnDate={activeAsnDate}
          shifts={shifts}
          asns={asns}
          refreshData={reloadData}
          bulkAssignShift={bulkAssignShift}
          title={title}
        />
      )}
    </div>
  );
};

BulkOptionsToolbar.propTypes = {
  line: PropTypes.object.isRequired,
  activeAsnDate: PropTypes.any,
  selectedAsns: PropTypes.arrayOf(
    PropTypes.shape({
      asnId: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      isChecked: PropTypes.bool.isRequired,
    }),
  ),
  asns: PropTypes.arrayOf(
    PropTypes.shape({
      asnId: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }),
  ),
  reloadData: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  closeNextMonthVinForm: PropTypes.func.isRequired,
  isAssignShiftFormOpen: PropTypes.bool.isRequired,
  isNextMonthFormOpen: PropTypes.bool.isRequired,
  assignShift: PropTypes.func.isRequired,
  nextMonthVINRequest: PropTypes.func.isRequired,
  bulkAssignShift: PropTypes.func.isRequired,
  classNames: PropTypes.object,
  title: PropTypes.string,
  shifts: PropTypes.array.isRequired,
  isAssignShiftFormDataLoading: PropTypes.bool.isRequired,
};

export default withAllowedOperationsProvider(
  BulkOptionsToolbar,
  false,
  RESOURCE_TYPE.CHASSIS,
);
